import { ActionIcon, Textarea, TextareaProps } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import AbsoluteError from '@/components/ui/AbsoluteError';
import { FieldTextStore } from '@/stores/local/shared/form/FieldTextStore';
import { useDevices } from '@/utils/devices';

export type FieldTextareaProps = Omit<TextareaProps, 'value' | 'onChange' | 'disabled' | 'error' | 'withAsterisk'> & {
  store: FieldTextStore;
  withClear?: boolean;
};

const FieldTextarea: React.FC<FieldTextareaProps> = ({ store, withClear = false, rightSection, ...props }) => {
  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      store.setValue(e.target.value);
    },
    [store],
  );

  const onClear = React.useCallback(() => {
    if (withClear) {
      store.setValue('');
    }
  }, [store, withClear]);

  const { isCompactViewport } = useDevices();

  return (
    <Textarea
      onFocus={store.focus}
      onBlur={store.blur}
      size={isCompactViewport ? 'md' : 'lg'}
      error={store.hasError && <AbsoluteError error={store.error} />}
      value={store.value ?? ''}
      onChange={onChange}
      disabled={store.disabled}
      withAsterisk={store.required}
      rightSection={
        withClear && store.value ? (
          <ActionIcon variant="transparent" color="grey" onClick={onClear}>
            <IconX size={16} />
          </ActionIcon>
        ) : (
          rightSection
        )
      }
      {...props}
    />
  );
};

export default observer(FieldTextarea);
